var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2305,
    height: 2143,
    viewBox: "0 0 2305 2143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1651.66 115L1541.29 223.5L1170 330L654 308L512.5 330L317 308L0 394V2142.5H2305V115L2090.69 62.5L1912.01 0H1814.5L1651.66 115Z",
    fill: "url(#paint0_linear_83_86)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_86",
    x1: 1837.76,
    y1: 31.5,
    x2: 1809.67,
    y2: 583.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AA59C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEDBD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector3.b0cc75a71f8a887955070f1e80fd73e5.svg";
export { ForwardRef as ReactComponent };